export default defineNuxtRouteMiddleware((to) => {
  if (to.fullPath.includes('/rewards')) {
    return navigateTo(
      {
        hash: to.hash,
        path: '/',
        query: {
          ...to.query,
          open_rewards: 'true',
        },
      },
      { replace: true },
    )
  }
})
